import type { GeneralWorkSchedule } from './types'

export const DEFAULT_WORKING_DAYS = '2,3,4,5,6'

export const DAY_OPTIONS = [
  { label: 'Thứ hai', value: 1 },
  { label: 'Thứ ba', value: 2 },
  { label: 'Thứ tư', value: 3 },
  { label: 'Thứ năm', value: 4 },
  { label: 'Thứ sáu', value: 5 },
  { label: 'Thứ bảy', value: 6 },
  { label: 'Chủ nhật', value: 7 },
]

export const FLAT_FORM_CLASS =
  '[&_.ant-card]:!border-0 [&_.ant-card]:!shadow-none [&_.ant-card-body]:!p-0'

export const DEFAULT_GENERAL_SCHEDULE: GeneralWorkSchedule = {
  id: 'default',
  days: [],
  workFrom: '',
  workTo: '',
}
